export default __webpack_public_path__ + "static/media/pricelist-banner.04658ba3.jpg";